import { useEffect } from 'react';

/**
 * Custom hook for PartnerStack integration
 * Only loads the PartnerStack script when the environment variable is present
 */
const usePartnerStackIntegration = () => {
  useEffect(() => {
    // Check if PartnerStack key is available in environment variables
    const partnerStackKey = process.env?.REACT_APP_PARTNERSTACK_KEY;
    
    if (!partnerStackKey) {
      console.log('PartnerStack key not found in environment variables. Skipping integration.');
      return;
    }

    // Check if PartnerStack script is already loaded
    const existingScript = document.querySelector('script[src*="partnerstack.com"]');
    if (existingScript) {
      console.log('PartnerStack script already loaded.');
      return;
    }

    // Create and load PartnerStack script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://js.partnerstack.com/v1/';
    
    script.onload = script.onreadystatechange = function() {
      const readyState = this.readyState;
      if (readyState && readyState !== 'complete' && readyState !== 'loaded') {
        return;
      }
      
      try {
        // Initialize PartnerStack with the key from environment variables
        if (window.growsumo && typeof window.growsumo._initialize === 'function') {
          window.growsumo._initialize(partnerStackKey);
          console.log('PartnerStack initialized successfully');
        }
        
        // Call growsumoInit if it exists
        if (typeof window.growsumoInit === 'function') {
          window.growsumoInit();
        }
      } catch (error) {
        console.error('Error initializing PartnerStack:', error);
      }
    };

    script.onerror = function() {
      console.error('Failed to load PartnerStack script');
    };

    // Insert the script into the document
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    // Cleanup function
    return () => {
      // Remove the script when component unmounts
      const scriptToRemove = document.querySelector('script[src*="partnerstack.com"]');
      if (scriptToRemove && scriptToRemove.parentNode) {
        scriptToRemove.parentNode.removeChild(scriptToRemove);
      }
    };
  }, []); // Empty dependency array means this runs once on mount

  return null; // This hook doesn't return any value
};

export default usePartnerStackIntegration;
